import { h, app } from 'hyperapp'; // eslint-disable-line no-unused-vars
import '@babel/polyfill';
import './index.scss';
import { Dropdown } from '../ApcHyperDropdown'; // eslint-disable-line no-unused-vars
import { ApcInput } from '../ApcInput'; // eslint-disable-line no-unused-vars

const LAST_ELEMENT_INDEX = 9;
const LAST_ELEMENT_VALUE = '10+';

export const view = ({ hiddenInputId, wrapper, originalValue }) => {
    const _elToString = el => {
        const newEl = el + 1;

        return newEl.toString();
    };

    const _getQtyOptions = (maxLength = 1) =>
        [...Array(maxLength).keys()].map((el, index) => ({
            value: index + 1,
            label: el === LAST_ELEMENT_INDEX ? LAST_ELEMENT_VALUE : _elToString(el),
        }));

    const options = _getQtyOptions(LAST_ELEMENT_INDEX + 1);

    const selectedOption = options.find(option => option.value === +originalValue);

    const toggleUpdateQuantityButton = newVal => {
        const originalValue1 = document.getElementById(hiddenInputId).dataset.originalValue;

        const updateQuantityButton = wrapper.querySelector('.update-quantity');

        if (+originalValue1 === +newVal || newVal === '') {
            updateQuantityButton.classList.add('hidden');
        } else {
            updateQuantityButton.classList.remove('hidden');
        }
    };

    const setValue = value => {
        const hiddenInputContainer = document.getElementById(hiddenInputId);
        const apcInput = wrapper.querySelector('.apcInputContainer .apc-input');

        apcInput.setAttribute('value', value);
        hiddenInputContainer.setAttribute('value', value);
    };

    const submitForm = value => {
        const originalValue1 = document.getElementById(hiddenInputId).dataset.originalValue;
        const updateQuantityButton = wrapper.querySelector('.update-quantity');

        if (+originalValue1 !== +value) {
            updateQuantityButton.click();
        }
    };

    const onInputBlur = event => {
        const { value } = event.target;
        setValue(value);
        toggleUpdateQuantityButton(value);
    };

    const onQtyChange = value => {
        if (value > LAST_ELEMENT_INDEX) {
            const inputContainer = wrapper.querySelector('.apcInputContainer');
            inputContainer.classList.remove('hidden');
            inputContainer.querySelector('.apc-input').focus(); // TODO: fix
            // The better approach is to first render the input only in that case
            // and not hide/show it with css classes. Will be fixed later,
            // too risky on current development stage.
            wrapper.querySelector('.apc-dropdown').classList.add('hidden');
        } else {
            setValue(value);
            submitForm(value);
        }
    };

    const onInput = ({ target }) => {
        toggleUpdateQuantityButton(target.value);
    };

    const onCreate = () => {
        const hiddenInputContainer = document.getElementById(hiddenInputId);
        const inputValue = hiddenInputContainer.value;

        hiddenInputContainer.addEventListener('change', onQtyChange);

        if (inputValue > LAST_ELEMENT_INDEX) {
            wrapper.querySelector('.apcInputContainer').classList.remove('hidden');
        }

        toggleUpdateQuantityButton(inputValue);
    };

    return (
        <div oncreate={onCreate}>
            <ApcInput
                onBlur={onInputBlur}
                onInput={onInput}
                defaultValue={originalValue}
                className={originalValue > LAST_ELEMENT_INDEX ? '' : 'hidden'}
                beforeSubmitInput={setValue}
            />
            {options.length ? (
                <Dropdown
                    items={_getQtyOptions(LAST_ELEMENT_INDEX + 1)}
                    placeholder=""
                    parentElement={wrapper}
                    selectedOption={selectedOption}
                    onchange={onQtyChange}
                    selectedItem={originalValue}
                    className={originalValue > LAST_ELEMENT_INDEX ? 'hidden' : ''}
                />
            ) : null}
        </div>
    );
};
